<div *ngIf="selecionado">
  <app-boxes-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-boxes-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-boxes-filtro [filtros]="filtros"></app-boxes-filtro>
  <app-boxes-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-boxes-lista>
</div>